export const getTicketProtocol = (ticket) => {
  if (!ticket || typeof ticket !== 'object') return null;
  const raw = ticket.protocolo ?? ticket.protocol ?? ticket.protocolNumber;
  if (raw == null) return null;
  const value = String(raw).trim();
  return value === '' ? null : value;
};

export const formatTicketProtocol = (ticket) => getTicketProtocol(ticket);

export const getTicketResponsibleUsers = (ticket, users = []) => {
  if (!ticket || typeof ticket !== 'object') return [];

  if (Array.isArray(ticket.responsibleUsers) && ticket.responsibleUsers.length > 0) {
    return ticket.responsibleUsers
      .filter(Boolean)
      .map((user) => {
        const email = user.email || '';
        const match = email ? users.find((u) => u?.email === email) : null;
        const name = user.name || match?.name || email || 'Usuário';
        return {
          id: user.id || email || name,
          email,
          name,
          photoUrl: user.photoUrl || match?.photoUrl || null,
        };
      });
  }

  const emails = Array.isArray(ticket.responsibleUserEmails)
    ? ticket.responsibleUserEmails
    : [];

  return emails.filter(Boolean).map((email) => {
    const match = users.find((user) => user?.email === email);
    return {
      id: match?.id || email,
      email,
      name: match?.name || email,
      photoUrl: match?.photoUrl || null,
    };
  });
};

export const formatResponsibleLabel = (emailsOrTicket, users) => {
  if (emailsOrTicket && typeof emailsOrTicket === 'object' && !Array.isArray(emailsOrTicket)) {
    const list = getTicketResponsibleUsers(emailsOrTicket, users);
    if (list.length === 0) return null;
    return list.map((user) => user.name).join(', ');
  }

  if (!Array.isArray(emailsOrTicket) || emailsOrTicket.length === 0) return null;
  return emailsOrTicket
    .map((email) => {
      const match = users?.find((user) => user?.email === email);
      return match?.name || email;
    })
    .join(', ');
};
